import { render } from "./TSV.vue?vue&type=template&id=ff9f3ea4"
import script from "./TSV.vue?vue&type=script&lang=js"
export * from "./TSV.vue?vue&type=script&lang=js"

import "./TSV.vue?vue&type=style&index=0&id=ff9f3ea4&lang=scss"

import exportComponent from "C:\\Users\\Alexander\\Documents\\Hompage TT Tools\\TT Homapge Files\\Webseite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__